// extracted by mini-css-extract-plugin
module.exports = {"Heading":"SearchFeed_Heading__1IQ-6"};